/**
 * A mensagem a mostrar para um erro vindo da API. As respostas de erro vêm em JSON
 * (ProblemDetails: `detail` / `title`); mostrar o corpo em bruto punha um bloco de JSON no ecrã.
 * Serve qualquer erro com `status` e `message` — os módulos de API desta app lançam-nos assim.
 */
export function apiErrorMessage(error: unknown, fallback: string): string {
  const status = (error as { status?: unknown } | null)?.status;
  if (status === 401) return "Sessão expirada. Autentique-se novamente.";
  if (status === 403) return "Sem permissões para esta ação.";

  const message = error instanceof Error ? error.message : "";
  if (!message) return fallback;
  try {
    const parsed = JSON.parse(message);
    if (parsed && typeof parsed === "object") {
      const errors = parsed.errors && typeof parsed.errors === "object"
        ? (Object.values(parsed.errors).flat() as unknown[]).filter((item): item is string => typeof item === "string")
        : [];
      return errors[0] || parsed.detail || parsed.title || fallback;
    }
    if (typeof parsed === "string" && parsed.trim() !== "") return parsed;
  } catch {
    // Não é JSON: o texto serve tal como veio.
  }
  return message;
}
